import { api } from "shared/config/api/api";
import { TICKETS_LIST_TAG } from "entities/support-ticket";
import type {
  CreateTicketRequest,
  CreateTicketResponse,
} from "entities/support-ticket";

export const createTicketApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createTicket: builder.mutation<CreateTicketResponse, CreateTicketRequest>({
      query: (body) => ({
        url: "/support/tickets",
        method: "POST",
        body,
      }),
      invalidatesTags: [TICKETS_LIST_TAG],
    }),
  }),
});

export const { useCreateTicketMutation } = createTicketApi;
